import React from 'react';
import Frame from 'components/Frame';
import styled from 'styled-components';
import colors from 'const/style/colors';
import imgAlertChrome from 'assets/img/alert_chrome.png';

const ContentFrame = styled(Frame)`
  display:flex;
  flex-direction:column;
  flex-wrap:nowrap;
  justify-content:center;
  align-items:center;
  white-space:pre-line;
  font-size:24px;
  line-height:38px;
  color:rgb(51,51,51);
  .frame-row {
    margin-top:21px;
    text-align:center;
  }
  .btn-install-chrome {
    width:160px;
    height:40px;
    display:flex;
    justify-content:center;
    align-items:center;
    color:${colors.CFFFFFF};
    font-size:13px;
    background:rgb(33, 152, 173);
    border: 1px solid rgb(40, 139, 168);
    border-radius:20px;
  }
`;

const UnSupportBrowser = () => {
  return (
    <ContentFrame>
      <img src={imgAlertChrome} alt=''/>
      <div className='frame-row'>
        {`현재 사용하고 계신 브라우저에서는 서비스 이용이 불가능합니다.\n온라인 PT전형 서비스는 Chrome에 최적화되어 있습니다.`}
      </div>
      <div className='frame-row'>
        <a href='https://www.google.co.kr/chrome'>
          <button type='button' className='btn-install-chrome'>
            크롬 설치하기
          </button>
        </a>
      </div>
    </ContentFrame>
  )
}

export default UnSupportBrowser;